<!-- Trigger shows the state: "EN" linked, "EN / FR" separated (interface first). -->
<button
  type="button"
  class="trigger"
  cdkOverlayOrigin
  data-topbar-trigger="language"
  #origin="cdkOverlayOrigin"
  (click)="toggle()"
  [disabled]="!ready()"
  [attr.aria-busy]="!ready() ? true : null"
  [attr.aria-expanded]="open()"
  aria-haspopup="menu"
  [title]="
    !ready()
      ? null
      : separated()
        ? ('nav.topbar.language_tooltip_separated' | translate: { interface: uiLabel(), data: dataLabel() })
        : ('nav.topbar.language_tooltip_linked' | translate: { language: uiLabel() })
  "
  data-testid="languages-btn"
>
  <mat-icon class="globe" [class.dim]="!ready()">language</mat-icon>
  @if (ready()) {
    <span class="codes">
      {{ uiCode() }}
      @if (separated()) {
        <span class="slash">/</span>
        {{ dataCode() }}
      }
    </span>
  } @else {
    <!-- The code is known at boot, but it waits with the cluster: one real
         trigger between two placeholders reads as broken, not as progress. -->
    <span class="nbo-skel skel-code"></span>
  }
  <mat-icon class="chevron" [class.dim]="!ready()">expand_more</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 6 }
  ]"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="onBackdropClick($event)"
  (detach)="onDetach()"
>
  <div class="popover" [class.separated]="separated()" role="menu" data-testid="language-panel">
    @if (separated()) {
      <!-- Two captioned columns so the user can SEE that the lists differ. -->
      <div class="columns">
        <div class="column">
          <div class="caption">{{ 'nav.topbar.language_interface' | translate }}</div>
          @for (row of interfaceRows(); track row.code) {
            <button
              type="button"
              class="row"
              role="menuitemradio"
              [class.on]="isActive(row.code, uiCode())"
              [attr.aria-checked]="isActive(row.code, uiCode())"
              (click)="pickInterface(row.code)"
              data-testid="language-button"
            >
              <span class="gutter">{{ row.code }}</span>
              <span class="name">{{ row.label }}</span>
              @if (isActive(row.code, uiCode())) {
                <mat-icon class="check">check</mat-icon>
              }
            </button>
          }
        </div>
        <div class="column-rule"></div>
        <div class="column">
          <div class="caption">{{ 'nav.topbar.language_data' | translate }}</div>
          @for (row of dataRows(); track row.code) {
            <button
              type="button"
              class="row"
              role="menuitemradio"
              [class.on]="isActive(row.code, dataCode())"
              [attr.aria-checked]="isActive(row.code, dataCode())"
              (click)="pickData(row.code)"
              data-testid="data-language-button"
            >
              <span class="gutter">{{ row.code }}</span>
              <span class="name">{{ row.label }}</span>
              @if (isActive(row.code, dataCode())) {
                <mat-icon class="check">check</mat-icon>
              }
            </button>
          }
        </div>
      </div>
    } @else {
      <!-- Linked: ONE list at today's width. -->
      <div class="column">
        <div class="caption">{{ 'nav.topbar.language_single' | translate }}</div>
        @for (row of interfaceRows(); track row.code) {
          <button
            type="button"
            class="row"
            role="menuitemradio"
            [class.on]="isActive(row.code, uiCode())"
            [attr.aria-checked]="isActive(row.code, uiCode())"
            (click)="pickInterface(row.code)"
            data-testid="language-button"
          >
            <span class="gutter">{{ row.code }}</span>
            <span class="name">{{ row.label }}</span>
            @if (isActive(row.code, uiCode())) {
              <mat-icon class="check">check</mat-icon>
            } @else if (row.interfaceOnly) {
              <span class="marker">{{ 'nav.topbar.language_interface_only' | translate }}</span>
            }
          </button>
        }
      </div>

      <!-- Never let a choice blank the screen: name what data resolves to. -->
      @if (strandedFallbackLabel()) {
        <div class="stranded">
          {{
            'nav.topbar.language_data_fallback'
              | translate: { data: strandedFallbackLabel(), interface: uiLabel() }
          }}
        </div>
      }
    }

    <!-- Footer verb, both directions. Single-data-language tenants get none. -->
    @if (!singleDataLanguage()) {
      <button type="button" class="footer" (click)="toggleLink()" data-testid="language-link-toggle">
        <mat-icon class="footer-icon">{{ separated() ? 'link' : 'link_off' }}</mat-icon>
        {{ (separated() ? 'nav.topbar.language_match_data' : 'nav.topbar.language_separate_data') | translate }}
      </button>
    }
  </div>
</ng-template>
